const focusableSelectors = [
  'a[href]',
  'button',
  'textarea',
  'input',
  'select',
  '[tabindex]:not([tabindex="-1"])',
];

const focusableSelectorsString = focusableSelectors.join(',');

export function isElementFocusable(
  element: Element | null,
): element is HTMLElement {
  if (!element) return false;

  if (
    (element as HTMLInputElement).disabled ||
    (element as HTMLElement).offsetParent == null
  ) {
    return false;
  }

  return (
    (element instanceof HTMLAnchorElement && element.href != null) ||
    element instanceof HTMLButtonElement ||
    element instanceof HTMLInputElement ||
    element instanceof HTMLTextAreaElement ||
    element instanceof HTMLSelectElement ||
    (element.hasAttribute('tabindex') &&
      element.getAttribute('tabindex') !== '-1')
  );
}

/**
 * Imposta il focus sull'elemento successivo a quello passato come argomento.
 */
export function focusNextElement(element: Element | null) {
  if (!element) return;

  try {
    // Ottieni tutti gli elementi focusabili
    const focusableElements = Array.from(
      document.querySelectorAll(focusableSelectorsString),
    ).filter(
      el =>
        !(el as HTMLInputElement).disabled &&
        (el as HTMLElement).offsetParent !== null,
    );

    const currentIndex = focusableElements.indexOf(element);
    // Se non è stato trovato alcun elemento focusabile, annullo l'operazione
    if (currentIndex === -1) return;

    const nextElement = focusableElements[
      (currentIndex + 1) % focusableElements.length
    ] as HTMLElement;
    nextElement?.focus();
  } catch (e) {
    console.warn(
      "[ui/a11y] Si è verificato un errore durante il focus sull'elemento successivo:",
      e,
    );
  }
}

/**
 * Imposta il focus sul primo elemento focusabile interno all'elemento o
 * sull'elemento stesso se è focusabile.
 */
export function focusFirstAvailableElement(element: Element | null) {
  if (!element) return;

  try {
    if (isElementFocusable(element)) {
      element.focus();
      return;
    }

    const focusableElements = Array.from(
      element.querySelectorAll(focusableSelectorsString),
    ).filter(
      el =>
        !(el as HTMLInputElement).disabled &&
        (el as HTMLElement).offsetParent !== null,
    );

    const firstElement = focusableElements[0] as HTMLElement;
    if (!firstElement) {
      console.warn(
        "[ui/a11y] Non è stato trovato alcun elemento focusabile all'interno dell'elemento.",
        element,
      );
      return;
    }

    firstElement.focus();
  } catch (e) {
    console.warn(
      '[ui/a11y] Si è verificato un errore durante il focus sul primo elemento interno:',
      e,
    );
  }
}
